import React from 'react';
import { CardDeck, Button } from 'react-bootstrap';
import { useContext } from 'react';
import { DataContext } from '../Layouts';
import Work from './Work/Work';
import { useState } from 'react';

const AllWorks = () => {
    const {allWorks} = useContext(DataContext); 
    const [limit, setLimit] = useState(6);
    const limitedWorks = allWorks.slice(0,limit);

    return (
        <div className="my-5">
            <CardDeck>
                {
                limitedWorks.map((work,index) => <Work key={index} work={work}/>)
                }
            </CardDeck>

            {
                limit < allWorks.length &&  <div className="text-center">
                <Button 
                onClick={() => {
                    setLimit(limit + 6)
                }}
                variant="outline-success">See More</Button>
            </div>
            }
        </div>
    );
};

export default AllWorks;